import { createFileRoute } from '@tanstack/react-router';
import ClientDashboard from '../../components/client/ClientDashboard';
import ClientPortal from '../../components/portals/ClientPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockUser } from '../../data/mockData';

export const Route = createFileRoute('/client/')({
  component: ClientDashboardRoute,
});

function ClientDashboardRoute() {
  const { user, isManager } = useAuth();
  const content = <ClientDashboard user={user && !isManager ? user : mockUser} />;
  return <ClientPortal>{content}</ClientPortal>;
}
